/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quickcreateclose2Inputs */

const en_quickcreateclose2 = /** @type {(inputs: Quickcreateclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const de_quickcreateclose2 = /** @type {(inputs: Quickcreateclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü schließen`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Quickcreateclose2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const quickcreateclose2 = /** @type {((inputs?: Quickcreateclose2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickcreateclose2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quickcreateclose2(inputs)
	return de_quickcreateclose2(inputs)
});
export { quickcreateclose2 as "quickCreateClose" }